import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";

class UrlService{
    getSuperUserLinks() {
        return axios.get(UrlHelper.getIdentifiApiUrl() + 'urls/superusertools');
    }

    getApplicationLinks (showLoginPageUrls) {
        return axios.post(UrlHelper.getIdentifiUrl() + 'Url/GetApplicationLinks');
    }

    // 'Use-Virtual-Session' - used on ProductSelector (runs in VirtualSession)
    getAvailableApplications (returnUrl) {
        const url = returnUrl ? returnUrl : "";
        return axios
            .get(UrlHelper.getIdentifiApiUrl() + 'availableApplications?returnUrl=' + url, {
                headers: {
                    'Use-Virtual-Session': true
                }
            });
    }
}

export default new UrlService();
